export const getLoggedInUser = () =>
  JSON.parse(localStorage.getItem("med_user"));
